import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/**計上月度のENUM*/
enum EntryDateSelection {
  currentMonth = '101',
  currentPeriod = '102',
  upToCurrentMonth = '103',
}

const nameConfig = {
  currentMonth: new Map([
    [Locale.ja, '当月'],
    [Locale.en, 'Current Month'],
  ]),
  currentPeriod: new Map([
    [Locale.ja, '当期'],
    [Locale.en, 'Current Period'],
  ]),
  upToCurrentMonth: new Map([
    [Locale.ja, '当月まで'],
    [Locale.en, 'Up to Current Month'],
  ]),
};

const toEnum = rawValueToEnum(EntryDateSelection, EntryDateSelection.currentMonth);
const toDisplay = enumToName(EntryDateSelection, nameConfig);
const toDisplayWithPrefix = enumToName(EntryDateSelection, nameConfig, { prefix: true });

export const entryDateSelection = {
  enum: EntryDateSelection,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { EntryDateSelection };
